"use client";
import {useState} from "react";
import CWFResponsiveSheet from "@/components/ui/CWFResponsiveSheet";
import CWFButton from "@/components/ui/CWFButton";
import TimePicker from "@/components/Calendar/TimePicker";

export default function ReservationPanel({profile, offer, userIsLoggedIn, userId, btnTitle = "Réserver", shared = false }){
    const [isOpen, setIsOpen] = useState(false);

    return(
        <>
            <CWFButton
                disabled={!profile.availability || (!profile?.profile?.hourly_rate && !shared) || offer.user_id === userId ||  !userIsLoggedIn}
                onClick={()=> {
                    setIsOpen(true);
                }}
            >
                {btnTitle}
            </CWFButton>
            <CWFResponsiveSheet
                onOpenChange={setIsOpen}
                open={isOpen}
                trigger={null}
                className={"w-full md:max-w-2xl  md:w-3/4 overflow-y-scroll"}
            >
                <img src={offer.document?.path || "/imagedefault.png"} className="w-full h-1/2 md:h-1/3 object-contain aspect-square"/>
                <p className={"whitespace-pre-line pt-2"}>{offer.description}</p>
                <div className={"md:col-span-2"}>
                    {profile.availability && (
                        <TimePicker bookingTimes={JSON.parse(profile.availability.availabilities)} length={offer.time}
                                    offerId={offer.id} userId={profile.id} profile={profile}/>
                    )}
                </div>
            </CWFResponsiveSheet>
        </>
    )
}